import { TPayoutFilters, TPayoutInfo } from "../bloc/payoutsSlice";


export const getUpdatedPayouts = (searchText: string, payouts: TPayoutInfo[], filters: TPayoutFilters) => {
    let updatedPayouts = payouts;
    if (searchText.length > 0) {
        updatedPayouts = payouts.filter((payout) =>
            payout.utr.toLowerCase().includes(searchText.toLocaleLowerCase()) ||
            payout.receiver.toLowerCase().includes(searchText.toLocaleLowerCase()) ||
            payout.payoutId.toLowerCase().includes(searchText.toLocaleLowerCase())
        );
    }
    if (filters.selectedTypes.length > 0) {
        updatedPayouts = updatedPayouts.filter((payout) => filters.selectedTypes.includes(payout.type));
    }
    if (filters.selectedStatuses.length > 0) {
        updatedPayouts = updatedPayouts.filter((payout) =>
            filters.selectedStatuses.map((s) => s.toLocaleLowerCase()).includes(payout.status.toLocaleLowerCase()));
    }
    if (filters.selectedCustomers.length > 0) {
        updatedPayouts = updatedPayouts.filter((payout) => filters.selectedCustomers.includes(payout.benCode));
    }
    return updatedPayouts;
}